import React from "react";
import ProductDossierHeader from "../components/ProductDossierComponents/DossierHeader";
import ProductImageCard from "../components/ProductDossierComponents/ProductImageCard";
import ProductProducerCard from "../components/ProductDossierComponents/ProductProducerCard";
import ProductSummaryCard from "../components/ProductDossierComponents/ProductSummaryCard";
import ProductAlertBar from "../components/ProductDossierComponents/ProductAlertBar";
import ProductAttachmentsTable from "../components/ProductDossierComponents/ProductAttachmentsTable";
import ProductBottomFooter from "../components/ProductDossierComponents/ProductBottomFooter";

export default function ProductDossierPage() {
  return (
    <>
      <div className="pdp-page">
        <div className="pdp-shell">
          <ProductDossierHeader />

          <div className="pdp-top-grid">
            <div className="pdp-left">
              <ProductImageCard />
            </div>

            <div className="pdp-center">
              <ProductProducerCard />
            </div>

            <div className="pdp-right">
              <ProductSummaryCard />
            </div>
          </div>

          <ProductAlertBar />
          <ProductAttachmentsTable />
          <ProductBottomFooter />
        </div>
      </div>

      <style>{`
        * {
          box-sizing: border-box;
        }

        .pdp-page {
          min-height: 100vh;
          padding: 18px;
          background:
            radial-gradient(circle at top left, rgba(70,114,255,0.18), transparent 24%),
            radial-gradient(circle at bottom right, rgba(75,120,255,0.12), transparent 28%),
            linear-gradient(180deg, #091020 0%, #0b1328 45%, #09101f 100%);
          font-family: "Manrope", system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
        }

        .pdp-shell {
          width: 100%;
          max-width: 1460px;
          margin: 0 auto;
        }

        .pdp-top-grid {
          display: grid;
          grid-template-columns: 1.12fr 1.1fr 0.92fr;
          gap: 16px;
          margin-top: 16px;
          align-items: start;
        }

        .pdp-left,
        .pdp-center,
        .pdp-right {
          min-width: 0;
        }

        @media (max-width: 1200px) {
          .pdp-top-grid {
            grid-template-columns: 1fr;
          }
        }

        @media (max-width: 760px) {
          .pdp-page {
            padding: 12px;
          }
        }
      `}</style>
    </>
  );
}